import React from 'react';
import macroStr from 'latex2js-macros';
export default (function () {
  return (
    /*#__PURE__*/
    React.createElement("div", {
      style: {
        display: 'none'
      },
      dangerouslySetInnerHTML: {
        __html: macroStr
      }
    })
  );
});